/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';

import PropTypes from 'prop-types';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import LocaleMessage from '~/components/LocaleMessage';

import api from '~/services/pluginbot-api';

export default function VoiceDestinations({
    handleError,
    robotType,
    settings,
    setSettings,
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [destinations, setDestinations] = useState([]);

    async function loadVoices(robot) {
        const r_type = robot.slug || '';
        return api
            .get(
                `applications/conversation/voices?types=${JSON.stringify([
                    r_type,
                ])}`
            )
            .then(response => {
                const { data } = response;
                const def_voices = [];
                const rt_voices = data && data[r_type] ? data[r_type] : {};
                const rt_sources =
                    rt_voices && rt_voices.sources ? rt_voices.sources : [];
                rt_sources.forEach(s => {
                    const voice_config = {
                        id: `voice_source_${s}`,
                        name: (
                            <LocaleMessage
                                msg={`page.applications.conversation.language.source.${s}`}
                            />
                        ),
                        type: s,
                    };
                    def_voices.push(voice_config);
                });
                return def_voices;
            })
            .catch(e => {
                handleError(e);
                return [];
            });
    }

    async function loadGeneratorVoices() {
        return api
            .get(`generators/voices`)
            .then(response => {
                const { data } = response;
                if (data && typeof data === 'object' && data[0]) {
                    return data;
                }
                return [];
            })
            .catch(e => {
                handleError(e);
                return [];
            });
    }

    async function loadAllVoices(robot) {
        const r_id = robot.id || '';
        if (r_id) {
            setIsLoading(true);
            const defaults = await loadVoices(robot);
            const generators = await loadGeneratorVoices();
            setDestinations([...defaults, ...generators]);
        } else {
            setDestinations([]);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        if (robotType) {
            loadAllVoices(robotType);
        }
    }, [robotType]);

    function saveBody(key, value) {
        setSettings({
            ...settings,
            [key]: value,
        });
    }

    return isLoading ? (
        <ReactLoading type="bars" color="#c8c8c8" height={50} width={50} />
    ) : (
        <div
            className="row col-12"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div className="col-md-5 col-12">
                <FormControl className="mb-5" fullWidth>
                    <InputLabel>
                        <LocaleMessage msg="page.applications.conversation.triggers.identifiers.voice" />
                    </InputLabel>
                    <Select
                        value={settings.voice ? settings.voice : ''}
                        onChange={event =>
                            saveBody('voice', event.target.value)
                        }
                    >
                        {destinations.map(v => {
                            return (
                                <MenuItem value={v.id} key={v.id}>
                                    {v.name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </div>
        </div>
    );
}

VoiceDestinations.defaultProps = {};

VoiceDestinations.propTypes = {
    settings: PropTypes.object.isRequired,
    setSettings: PropTypes.func.isRequired,
    handleError: PropTypes.func.isRequired,
    robotType: PropTypes.object.isRequired,
};
